import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../api/client'
import OnboardingWizard from '../components/onboarding/OnboardingWizard'
import Spinner from '../components/Spinner'

export default function OnboardingPage() {
  const navigate = useNavigate()
  const [companyId, setCompanyId] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await api.get('/auth/me')
        const id = response?.data?.tenant_id ?? response?.data?.company_id
        if (!id) {
          navigate('/dashboard', { replace: true })
          return
        }
        setCompanyId(String(id))
      } catch (error) {
        console.error('Error fetching session for onboarding:', error)
        navigate('/login?next=/onboarding', { replace: true })
      } finally {
        setLoading(false)
      }
    }

    checkSession()
  }, [navigate])

  if (loading) return <div className="ci-page"><Spinner label="Loading…" /></div>

  if (!companyId) {
    return null
  }

  return <OnboardingWizard companyId={companyId} />
}
